function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.54547,
  cy: 6.54547,
  r: 6.54547,
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.7274,
  cy: 6.54547,
  r: 6.54547,
  fill: "current"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 58.909,
  cy: 6.54547,
  r: 6.54547,
  fill: "current"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 85.0914,
  cy: 6.54547,
  r: 6.54547,
  fill: "current"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 137.455,
  cy: 6.54547,
  r: 6.54547,
  fill: "current"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 111.273,
  cy: 6.54547,
  r: 6.54547,
  fill: "current"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.54547,
  cy: 32.7269,
  r: 6.54547,
  fill: "current"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.7274,
  cy: 32.7269,
  r: 6.54547,
  fill: "current"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 58.909,
  cy: 32.7269,
  r: 6.54547,
  fill: "current"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 85.0914,
  cy: 32.7269,
  r: 6.54547,
  fill: "current"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 137.455,
  cy: 32.7269,
  r: 6.54547,
  fill: "current"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 111.273,
  cy: 32.7269,
  r: 6.54547,
  fill: "current"
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.54547,
  cy: 58.9092,
  r: 6.54547,
  fill: "current"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.7274,
  cy: 58.9092,
  r: 6.54547,
  fill: "current"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 58.909,
  cy: 58.9092,
  r: 6.54547,
  fill: "current"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 85.0914,
  cy: 58.9092,
  r: 6.54547,
  fill: "current"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 137.455,
  cy: 58.9092,
  r: 6.54547,
  fill: "current"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 111.273,
  cy: 58.9092,
  r: 6.54547,
  fill: "current"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.54547,
  cy: 85.0911,
  r: 6.54547,
  fill: "current"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.7274,
  cy: 85.0911,
  r: 6.54547,
  fill: "current"
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 58.909,
  cy: 85.0911,
  r: 6.54547,
  fill: "current"
});

var _ref23 = /*#__PURE__*/React.createElement("circle", {
  cx: 85.0914,
  cy: 85.0911,
  r: 6.54547,
  fill: "current"
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  cx: 137.455,
  cy: 85.0911,
  r: 6.54547,
  fill: "current"
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  cx: 111.273,
  cy: 85.0911,
  r: 6.54547,
  fill: "current"
});

var _ref26 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.54547,
  cy: 111.273,
  r: 6.54547,
  fill: "current"
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.7274,
  cy: 111.273,
  r: 6.54547,
  fill: "current"
});

var _ref28 = /*#__PURE__*/React.createElement("circle", {
  cx: 58.909,
  cy: 111.273,
  r: 6.54547,
  fill: "current"
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  cx: 85.0914,
  cy: 111.273,
  r: 6.54547,
  fill: "current"
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  cx: 137.455,
  cy: 111.273,
  r: 6.54547,
  fill: "current"
});

var _ref31 = /*#__PURE__*/React.createElement("circle", {
  cx: 111.273,
  cy: 111.273,
  r: 6.54547,
  fill: "current"
});

var _ref32 = /*#__PURE__*/React.createElement("circle", {
  cx: 6.54547,
  cy: 137.454,
  r: 6.54547,
  fill: "current"
});

var _ref33 = /*#__PURE__*/React.createElement("circle", {
  cx: 32.7274,
  cy: 137.454,
  r: 6.54547,
  fill: "current"
});

var _ref34 = /*#__PURE__*/React.createElement("circle", {
  cx: 58.909,
  cy: 137.454,
  r: 6.54547,
  fill: "current"
});

var _ref35 = /*#__PURE__*/React.createElement("circle", {
  cx: 85.0914,
  cy: 137.454,
  r: 6.54547,
  fill: "current"
});

var _ref36 = /*#__PURE__*/React.createElement("circle", {
  cx: 137.455,
  cy: 137.454,
  r: 6.54547,
  fill: "current"
});

var _ref37 = /*#__PURE__*/React.createElement("circle", {
  cx: 111.273,
  cy: 137.454,
  r: 6.54547,
  fill: "current"
});

function SvgMisc6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMisc6);
export default __webpack_public_path__ + "static/media/misc6.369d2aea.svg";
export { ForwardRef as ReactComponent };